import { initial_state } from "./initial_state";

export const reducer = (state = initial_state, action) => {
    switch (action.type) {
        case "language":
            return { ...state, language: action.language }
        default:
            return state
    }
}